import { HttpHeaders } from '@angular/common/http';

/**
 * Builds HTTP request options with an optional If-Match header from the given etag.
 * Normalizes etag by stripping leading/trailing double-quotes.
 * Returns an empty object when etag is null, undefined, or empty (before or after normalization).
 */
export function buildIfMatchOptions(etag: string | null | undefined): { headers?: HttpHeaders } {
  if (etag == null || etag === '') {
    return {};
  }
  const normalizedEtag = etag.replace(/^"+|"+$/g, '');
  if (normalizedEtag === '') {
    return {};
  }
  return { headers: new HttpHeaders({ 'If-Match': normalizedEtag }) };
}
